import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import {ApiCallService} from "../../../../services/api-call.service";
import {RequestCountHttpInterceptorService} from "../../../../services/request-count-http-interceptor.service";
import { NotificationsService } from "../../../../services/notifications.service";
import { Subscription } from "rxjs";
import { environment } from "../../../../../environments/environment";

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: false
})
export class NotificationsComponent implements OnInit, OnDestroy {

  public notifications = [];
  public hasUnread:boolean = false;
  public notificationsCount: number = 0;
  @Input() currentUser;
  @Output() closeMenu: EventEmitter<boolean> = new EventEmitter<boolean>();
  subscribers: Subscription[] = [];

  continuePolling:boolean = true;
  expanded: boolean = false;

  constructor(
    private apiCall: ApiCallService,
    private requestCountHttpInterceptorService: RequestCountHttpInterceptorService,
    private notificationsService: NotificationsService
  ) { }

  ngOnInit() {
    this.subscribers.push(
      this.notificationsService.notifications.subscribe(data => {
        this.notifications = data;
      }),
      this.notificationsService.hasNotifications.subscribe(data => {
        this.hasUnread = data;
      }),
      this.notificationsService.notificationsCount.subscribe(data => {
        this.notificationsCount = data;
      })
    );
  }

  closeMenuEvent(){
    this.closeMenu.emit(true);
  }

  showNotifications() {
    this.expanded = !this.expanded;
    if(this.expanded) {
      this.notificationsService.getUnreadNotifications();
    }
  }

  ngOnDestroy() {
    this.continuePolling = false;
    for(let subscriber of this.subscribers){
      subscriber.unsubscribe();
    }
  }
}
